import { useState } from "react";
import { Dropdown } from "react-bootstrap";
import IconResource from "../../Wrapper/IconResource/IconResource";

const WhatsAppInboxSIdebar = ({ onChatSelect, selectedChat }) => {
  const [conversations] = useState([
    {
      id: 1,
      name: "KK",
      initials: "K",
      lastMessage: "Cc",
      time: "1 min",
      subtitle: "Kusha...",
      unread: false,
      online: true,
    },
    {
      id: 2,
      name: "Rahul Sharma",
      initials: "RS",
      lastMessage: "Thanks for the update!",
      time: "5 min",
      subtitle: "+919876543210",
      unread: true,
      online: false,
    },
    {
      id: 3,
      name: "Priya Singh",
      initials: "PS",
      lastMessage: "When is the meeting?",
      time: "12 min",
      subtitle: "priya@example.com",
      unread: false,
      online: true,
    },
    {
      id: 4,
      name: "Amit Kumar",
      initials: "AK",
      lastMessage: "Can you send the file?",
      time: "1 hr",
      subtitle: "+919988776655",
      unread: true,
      online: false,
    },
    {
      id: 5,
      name: "Sneha Gupta",
      initials: "SG",
      lastMessage: "See you tomorrow",
      time: "2 hrs",
      subtitle: "sneha@example.com",
      unread: false,
      online: false,
    },
  ]);

  return (
    <div className="conversation_sidebar_inner">
      {/* Search Bar */}
      <div className="sidebar_search_container">
        <div className="sidebar_search_box">
          <IconResource type="search" className="sidebar_search_icon" />
          <input type="text" placeholder="Search" className="sidebar_search_input" />
        </div>
      </div>

      {/* Filter Section */}
      <div className="sidebar_filter_section">
        <Dropdown className="sidebar_all_dropdown">
          <Dropdown.Toggle className="all_dropdown_btn">
            All <span className="all_count_badge">1</span>
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item>All Messages</Dropdown.Item>
            <Dropdown.Item>Unread</Dropdown.Item>
            <Dropdown.Item>Archived</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

        <div className="sidebar_filter_icons">
          <button className="sidebar_filter_icon_btn">
            <IconResource type="onlyFilter" />
          </button>
          <button className="sidebar_filter_icon_btn">
            <IconResource type="controlsIcon" />
          </button>
        </div>
      </div>

      {/* Sandbox Mode Banner */}
      <div className="sandbox_mode_banner">
        <span>Yore using sandbox mode</span>
        <IconResource type="info" className="sandbox_info_icon" />
      </div>

      {/* Conversation List */}
      <div className="sidebar_conversation_list">
        {conversations.map((chat) => (
          <>
            <div
              key={chat.id}
              className={`sidebar_conversation_item ${selectedChat?.id === chat.id ? "active" : ""}`}
              onClick={() => onChatSelect(chat)}
            >
              <div className="d-flex align-items-center w-100">
                <div className="sidebar_avatar_container">
                  <div className="sidebar_user_avatar">{chat.initials}</div>
                </div>

                <div className="sidebar_conversation_details">
                  <div className="sidebar_conversation_header">
                    <h6 className="sidebar_user_name">{chat.name}</h6>
                    <div className="d-flex align-items-center">
                      {chat.online && <p className="sidebar_online_dot"></p>}
                      <span className="sidebar_time_badge">{chat.time}</span>
                    </div>
                  </div>
                  <div className="sidebar_conversation_footer">
                    <p className="sidebar_last_message">{chat.lastMessage}</p>
                  </div>
                </div>
              </div>
              <span className="sidebar_user_subtitle">{chat.subtitle}</span>
            </div>
          </>
        ))}
      </div>
    </div>
  );
};

export default WhatsAppInboxSIdebar;
